import {
    SET_CLIENT_INFO_SELECTED_STATE,
    SET_CLIENT_INFO_IS_OPEN,
    SET_CLIENT_INFO_COMPANY_NAME,
    SET_CLIENT_INFO_STREET,
    SET_CLIENT_INFO_STREET_2,
    SET_CLIENT_INFO_ZIP,
    SET_CLIENT_INFO_CITY,
    SET_COUNTRY,
    SET_CUSTOMER,
    ERASE_CUSTOMER,
} from './constants';

const defaultState = {
    selectedState: null,
    isOpen: true,
    companyName: '',
    street: '',
    street2: '',
    Zip: '',
    city: '',
    country: 'USA',
};

const clientInfoUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_CUSTOMER:
            return {
                companyName: action.customer.companyName,
                selectedState: action.customer.address.state,
                street: action.customer.address.address1,
                street2: action.customer.address.address2,
                city: action.customer.address.city,
                Zip: action.customer.address.zipCode,
                country: action.customer.address.country,
            };
        case ERASE_CUSTOMER:
            return {
                companyName: null,
                selectedState: null,
                street: null,
                street2: null,
                city: null,
                Zip: null,
                country: null,
            };

        case SET_CLIENT_INFO_IS_OPEN:
            return { ...state, isOpen: action.isOpen };

        case SET_CLIENT_INFO_SELECTED_STATE:
            return { ...state, selectedState: action.selectedState };

        case SET_CLIENT_INFO_COMPANY_NAME:
            return { ...state, companyName: action.companyName };

        case SET_CLIENT_INFO_STREET:
            return { ...state, street: action.street };

        case SET_CLIENT_INFO_STREET_2:
            return { ...state, street2: action.street2 };

        case SET_CLIENT_INFO_CITY:
            return { ...state, city: action.city };

        case SET_CLIENT_INFO_ZIP:
            return { ...state, Zip: action.Zip };
        case SET_COUNTRY:
            return { ...state, country: action.country };

        default:
            return state;
    }
};

export default clientInfoUI;



// WEBPACK FOOTER //
// ./src/containers/AddClient/ClientInfo/reducer.js